"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Handle = void 0;
exports.default = SortableMenuItem;
var _sortable = require("@dnd-kit/sortable");
var _utilities = require("@dnd-kit/utilities");
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../svg/Icon");
var _excluded = ["value", "className", "handle", "listeners"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var classNames = function classNames() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }
  return names.map(function (name) {
    return name !== null && name !== void 0 ? name : '';
  }).join(' ');
};
var Handle = function Handle(props) {
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: "tl-drag-handle"
  }, props), /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
    name: "icon-system-equal"
  }));
};
exports.Handle = Handle;
var Item = function Item(_ref) {
  var value = _ref.value,
    className = _ref.className,
    _ref$handle = _ref.handle,
    handle = _ref$handle === void 0 ? false : _ref$handle,
    listeners = _ref.listeners,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "tl-menu-list-option ".concat(className)
  }, props), value, handle ? /*#__PURE__*/_react.default.createElement(Handle, listeners) : null);
};
exports.Item = Item;
function SortableMenuItem(_ref2) {
  var id = _ref2.id,
    value = _ref2.value,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    itemClassName = _ref2.itemClassName,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$handle = _ref2.handle,
    handle = _ref2$handle === void 0 ? false : _ref2$handle;
  var _useSortable = (0, _sortable.useSortable)({
      id: id,
      disabled: disabled
    }),
    attributes = _useSortable.attributes,
    isDragging = _useSortable.isDragging,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var style = {
    transform: _utilities.CSS.Transform.toString(transform),
    transition: transition
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classNames(className, 'tl-dm-item-wrapper', handle ? '--with-handle' : '', isDragging ? 'tl-dragging' : '', disabled ? '--disabled' : ''),
    ref: setNodeRef,
    style: style
  }, attributes, !handle ? listeners : undefined), /*#__PURE__*/_react.default.createElement(Item, {
    className: classNames(itemClassName, isDragging ? 'tl-dragging-item' : ''),
    handle: handle,
    listeners: listeners,
    value: value
  }));
}